import React from "react"
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
export default function Footer() {
    const { t } = useTranslation();
    return (
        <>
            <footer className="bg-100 py-[80px]">
                <div className="container f-col flex justify-between gap-[50px]">
                    <div className="w-100 flex flex-col gap-[20px] w-[40%]">
                        <div>
                            <img className="h-[150px] w-[250px]" src={require("../../assets/logo/logo.png")} alt="" />
                        </div>
                        <p className="text-[14px] text-white">
                            M Power Moving Services, no job is too big or too small.
                            What began as a small local moving service has grown into a
                            trusted name for both local and long-distance moves across the U.S.
                        </p>
                    </div>
                    <div className="w-100 f-col gap-res-10 custom-gap-20 flex justify-between w-[50%]">
                        <div className="flex flex-col gap-[15px]">
                            <div className="flex flex-col gap-[4px]">
                                <span className="font-bold text-white text-[25px] capitalize">{t("helpful link")}</span>
                                <img className="h-[3px] w-[40px]" src={require("../../assets/icons/line-white.svg").default} alt="" />
                            </div>
                            <ul className="flex flex-col gap-[10px]">
                                <li>
                                    <Link className="flex items-center gap-[8px] text-white font-bold" to={"/"}>
                                        <img className="h-[12px] w-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                        <span>Home</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="flex items-center gap-[8px] text-white font-bold" to={"/about"}>
                                        <img className="h-[12px] w-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                        <span>About us</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="flex items-center gap-[8px] text-white font-bold" to={"/services"}>
                                        <img className="h-[12px] w-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                        <span>Services</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="flex items-center gap-[8px] text-white font-bold" to={"/faq"}>
                                        <img className="h-[12px] w-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                        <span>FAQs</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="flex items-center gap-[8px] text-white font-bold" to={"/contact"}>
                                        <img className="h-[12px] w-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                        <span>Contact us</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="flex items-center gap-[8px] text-white font-bold" to={"/claims"}>
                                        <img className="h-[12px] w-[12px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                        <span>Claims</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="flex flex-col gap-[15px]">
                            <div className="flex flex-col gap-[4px]">
                                <span className="font-bold text-white text-[25px] capitalize">Contact us</span>
                                <img className="h-[3px] w-[40px]" src={require("../../assets/icons/line-white.svg").default} alt="" />
                            </div>
                            <ul className="flex flex-col gap-[10px]">
                                <li>
                                    <Link className="flex items-center gap-[8px] text-white font-bold" to={"tel:888-890-6622"}>
                                        <div className="w-[25px] h-[25px] bg-white flex items-center justify-center rounded-full">
                                            <img className="h-[16px] w-[16px]" src={require("../../assets/icons/phone.svg").default} alt="" />
                                        </div>
                                        <span className="dir-ar">888-890-6622</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="flex items-center gap-[8px] text-white font-bold" to={"mainto:info@mpowermovingservices.com"}>
                                        <div className="w-[25px] h-[25px] bg-white flex items-center justify-center rounded-full">
                                            <img className="h-[16px] w-[16px]" src={require("../../assets/icons/email.svg").default} alt="" />
                                        </div>
                                        <span>info@mpowermovingservices.com</span>
                                    </Link>
                                </li>
                            </ul>
                            <div>
                                <div className="flex flex-col gap-[4px]">
                                    <span className="font-bold text-white text-[25px] capitalize"></span>
                                    <img className="h-[3px] w-[40px]" src={require("../../assets/icons/line-white.svg").default} alt="" />
                                </div>
                                <ul className="flex flex-col gap-[10px] mt-[30px]">
                                    <li>
                                        <Link className="flex items-center gap-[8px] text-white font-bold" to={"/"}>
                                            <span className="capitalize">US.DOT : 4222613</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="flex items-center gap-[8px] text-white font-bold" to={"/"}>
                                            <span className="capitalize">МС-1632369</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="font-13 flex items-center justify-center py-[15px] bg-[#294a6a] text-white font-bold text-center">
                {t("Copyright ©️ 2025 M Power Moving Services. All Rights Reserved.")}
            </div>
        </>
    )
}